import { Contract } from '@ethersproject/contracts';
import config from '@/config';
import { Interface } from '@ethersproject/abi';
import { abi as multicallAbi } from '../../abi/Multicall.json';
import { estimateGas, fetchUserBalance, sleep } from '.';
import abi from '../../abi';
import Web3 from 'web3';
import store from '../store';
import { MaxUint256 } from '@ethersproject/constants';
import BigNumber from 'bignumber.js';
import _ from 'lodash';
import provider from '@/helpers/provider';

export function scrollToTop() {
  window.scrollTo(0, 0);
}

export function getMarketplaceContractAddress(nftContractAddress: any) {
  const projects = config.projects;

  let marketplaceAddress = config.addresses.marketplaceAddress;
  _.forEach(projects, (project: any) => {
    _.forEach(project.collections, (collection: any) => {
      if (
        collection.nftContract.toLowerCase() ===
          nftContractAddress.toLowerCase() &&
        project.marketplaceAddress
      ) {
        marketplaceAddress = project.marketplaceAddress;
      }
    });
  });
  return marketplaceAddress;
}

export async function multicall(provider: any, abi: any, calls: any) {
  try {
    const multi = new Contract(
      config.addresses.multicall,
      multicallAbi,
      provider
    );
    const itf = new Interface(abi);
    const calldata = calls.map((call: any) => {
      return [
        call.address.toLowerCase(),
        itf.encodeFunctionData(call.name, call.params)
      ];
    });

    const { returnData } = await multi.aggregate(calldata);

    return returnData.map((call: any, i: any) =>
      itf.decodeFunctionResult(calls[i].name, call)
    );
  } catch (_e) {
    const e: any = _e;
    console.error('[multicall]', e.message);
    return null;
  }
}

export async function getMetadataFromURIs(tokenURIs: any) {
  if (!tokenURIs || tokenURIs.length === 0) {
    return [];
  }
  const metadata: any = [];

  const requests: any = [];
  for (let index = 0; index < tokenURIs.length; index++) {
    requests.push(fetch(tokenURIs[index]));
  }
  const res: any = await Promise.all(requests);
  for (let index = 0; index < tokenURIs.length; index++) {
    try {
      metadata.push(await res[index].json());
    } catch (_e) {
      const e: any = _e;
      console.error(
        `Loading data from ${tokenURIs[index]} throw error:`,
        e.message
      );
    }
  }
  return metadata;
}
export async function addMarketListing(
  nftContractAddr: any,
  tokenId: any,
  price: any,
  currency: any,
  startingDate: any,
  expirationDate: any,
  isArtWork: any,
  isEnableOffering: any
) {
  const provider = await store.getters['auth/authProvider'];
  const NFTContract = new Contract(
    nftContractAddr,
    abi['NFT721'],
    provider.getSigner()
  );
  let abiNFTContract = abi['BunicornMarketplace'];
  let marketAddress = config.projects.bunicornGame.marketplaceAddress;
  if (isArtWork) {
    abiNFTContract = abi['Marketplace'];
    marketAddress = config.addresses.marketplaceAddress;
  }
  const marketContract = new Contract(
    marketAddress,
    abiNFTContract,
    provider.getSigner()
  );

  try {
    const isApprovedAll = await NFTContract.isApprovedForAll(
      store.state.auth.address,
      marketAddress
    );

    if (!isApprovedAll) {
      const approveRes = await NFTContract.setApprovalForAll(
        marketAddress,
        true
      );
      await provider.waitForTransaction(
        approveRes.hash,
        Web3.givenProvider ? 1 : 6
      );
    }
  } catch (_e) {
    const e: any = _e;
    if (e.code && e.code === 4001) {
      throw e;
    }
    const approveRes = await NFTContract.approve(marketAddress, tokenId);
    await provider.waitForTransaction(
      approveRes.hash,
      Web3.givenProvider ? 1 : 6
    );
  }
  // Gas estimation
  const gasLimit = await estimateGas(marketContract, 'addListing', [
    nftContractAddr,
    tokenId,
    price,
    currency,
    startingDate,
    expirationDate,
    isEnableOffering
  ]);
  const overrides = {
    gasLimit
  };

  let res = await marketContract.addListing(
    nftContractAddr,
    tokenId,
    price,
    currency,
    startingDate,
    expirationDate,
    isEnableOffering,
    overrides
  );
  const transactionHash = res.hash;
  res = await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);

  const seller = store.state.auth.address;
  const nftID = tokenId;
  await sleep(9000);

  return { seller, nftID, price, transactionHash };
}
export async function addDutchAuctionListing(
  nftContractAddr: any,
  tokenId: any,
  startingPrice: any,
  endingPrice: any,
  decliningInterval: any,
  currency: any,
  startingTime: any,
  expirationTime: any,
  isEnableOffering: any
) {
  console.log(
    'testttt',
    nftContractAddr,
    tokenId,
    startingPrice,
    endingPrice,
    decliningInterval,
    currency,
    startingTime,
    expirationTime,
    isEnableOffering
  );
  const provider = await store.getters['auth/authProvider'];
  const NFTContract = new Contract(
    nftContractAddr,
    abi['NFT721'],
    provider.getSigner()
  );
  const abiNFTContract = abi['BunicornNFTAuctionMarketplace'];
  const marketAddress = config.addresses.bunicornNFTAuctionMarketplace;
  const marketContract = new Contract(
    marketAddress,
    abiNFTContract,
    provider.getSigner()
  );

  try {
    const isApprovedAll = await NFTContract.isApprovedForAll(
      store.state.auth.address,
      marketAddress
    );

    if (!isApprovedAll) {
      const approveRes = await NFTContract.setApprovalForAll(
        marketAddress,
        true
      );
      await provider.waitForTransaction(
        approveRes.hash,
        Web3.givenProvider ? 1 : 6
      );
    }
  } catch (_e) {
    const e: any = _e;
    if (e.code && e.code === 4001) {
      throw e;
    }
    const approveRes = await NFTContract.approve(marketAddress, tokenId);
    await provider.waitForTransaction(
      approveRes.hash,
      Web3.givenProvider ? 1 : 6
    );
  }
  // Gas estimation
  const gasLimit = await estimateGas(marketContract, 'addDutchAuctionListing', [
    nftContractAddr,
    tokenId,
    startingPrice,
    endingPrice,
    decliningInterval,
    currency,
    startingTime,
    expirationTime,
    isEnableOffering
  ]);
  const overrides = {
    gasLimit
  };

  let res = await marketContract.addDutchAuctionListing(
    nftContractAddr,
    tokenId,
    startingPrice,
    endingPrice,
    decliningInterval,
    currency,
    startingTime,
    expirationTime,
    isEnableOffering,
    overrides
  );
  const transactionHash = res.hash;
  res = await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);

  const seller = store.state.auth.address;
  const nftID = tokenId;
  await sleep(9000);

  return { seller, nftID, transactionHash };
}
export async function purchaseMarketListing(
  nftContractAddr: any,
  tokenId: any,
  maxPrice: any,
  currencyAddress: any
) {
  const provider = await store.getters['auth/authProvider'];
  const abiNFTContract = abi['Marketplace'];
  const marketAddress = getMarketplaceContractAddress(nftContractAddr);
  const currencyContract = new Contract(
    currencyAddress,
    abi['ERC20'],
    provider.getSigner()
  );

  const allowance = await currencyContract.allowance(
    store.state.auth.address,
    marketAddress
  );

  if (new BigNumber(maxPrice).gt(allowance.toString())) {
    try {
      const res1 = await currencyContract.approve(
        marketAddress,
        MaxUint256.toString()
      );
      await provider.waitForTransaction(res1.hash, Web3.givenProvider ? 1 : 6);
    } catch (_e) {
      const e: any = _e;
      if (e.code && e.code === 4001) {
        throw e;
      }
      const res2 = await currencyContract.approve(marketAddress, maxPrice);
      await provider.waitForTransaction(res2.hash, Web3.givenProvider ? 1 : 6);
    }
  }

  const marketContract = new Contract(
    marketAddress,
    abiNFTContract,
    provider.getSigner()
  );

  // Gas estimation
  const gasLimit = await estimateGas(marketContract, 'purchaseListing', [
    nftContractAddr,
    tokenId,
    maxPrice,
    currencyAddress
  ]);
  const overrides = {
    gasLimit
  };

  const res = await marketContract.purchaseListing(
    nftContractAddr,
    tokenId,
    maxPrice,
    currencyAddress,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;

  store.dispatch('myAccount/fetchBalances');
  return { tokenId, maxPrice, transactionHash };
}

export async function purchaseDutchAuctionListing(
  nftContractAddr: any,
  tokenId: any,
  maxPrice: any,
  currencyAddress: any
) {
  const provider = await store.getters['auth/authProvider'];
  const abiNFTContract = abi['BunicornNFTAuctionMarketplace'];
  const currencyContract = new Contract(
    currencyAddress,
    abi['ERC20'],
    provider.getSigner()
  );
  const marketAddress = config.addresses.bunicornNFTAuctionMarketplace;

  const allowance = await currencyContract.allowance(
    store.state.auth.address,
    marketAddress
  );

  if (new BigNumber(maxPrice).gt(allowance.toString())) {
    try {
      const res1 = await currencyContract.approve(
        marketAddress,
        MaxUint256.toString()
      );
      await provider.waitForTransaction(res1.hash, Web3.givenProvider ? 1 : 6);
    } catch (_e) {
      const e: any = _e;
      if (e.code && e.code === 4001) {
        throw e;
      }
      const res2 = await currencyContract.approve(marketAddress, maxPrice);
      await provider.waitForTransaction(res2.hash, Web3.givenProvider ? 1 : 6);
    }
  }

  const marketContract = new Contract(
    marketAddress,
    abiNFTContract,
    provider.getSigner()
  );

  // Gas estimation
  const gasLimit = await estimateGas(
    marketContract,
    'purchaseDutchAuctionListing',
    [nftContractAddr, tokenId]
  );
  const overrides = {
    gasLimit
  };

  const res = await marketContract.purchaseDutchAuctionListing(
    nftContractAddr,
    tokenId,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;

  store.dispatch('myAccount/fetchBalances');
  return { tokenId, maxPrice, transactionHash };
}

export async function getMarketPriceOfNft(nftContractAddress: any, nftId: any) {
  const marketAddress = getMarketplaceContractAddress(nftContractAddress);
  let marketAbi = abi['Marketplace'];
  const bunicornMarketplaceAddress =
    config.projects.bunicornGame.marketplaceAddress;
  if (
    marketAddress.toLowerCase() === bunicornMarketplaceAddress.toLocaleString()
  ) {
    marketAbi = abi['BunicornMarketplace'];
  }
  const marketContract = new Contract(marketAddress, marketAbi, provider);
  const [price, currency] = await marketContract.getFinalPrice(
    nftContractAddress,
    nftId
  );
  return [
    price.toString(),
    currency.toString() === '0x0000000000000000000000000000000000000000'
      ? config.addresses.buniAddress
      : currency.toString()
  ];
}
export async function cancelMarketListing(nftContractAddr: any, tokenId: any) {
  const authProvider = await store.getters['auth/authProvider'];
  const abiNFTContract = abi['Marketplace'];
  const marketAddress = getMarketplaceContractAddress(nftContractAddr);
  const marketContract = new Contract(
    marketAddress,
    abiNFTContract,
    authProvider.getSigner()
  );

  // Gas estimation
  const gasLimit = await estimateGas(marketContract, 'cancelListing', [
    nftContractAddr,
    tokenId
  ]);

  const overrides = {
    gasLimit
  };

  const res = await marketContract.cancelListing(
    nftContractAddr,
    tokenId,
    overrides
  );
  const transactionHash = res.hash;
  await provider.waitForTransaction(res.hash, 11);

  return { tokenId, transactionHash };
}

export async function cancelDutchAuctionListing(
  nftContractAddr: any,
  tokenId: any
) {
  const authProvider = await store.getters['auth/authProvider'];
  const abiNFTContract = abi['BunicornNFTAuctionMarketplace'];
  const marketAddress = config.addresses.bunicornNFTAuctionMarketplace;
  const marketContract = new Contract(
    marketAddress,
    abiNFTContract,
    authProvider.getSigner()
  );

  // Gas estimation
  const gasLimit = await estimateGas(
    marketContract,
    'cancelDutchAuctionListing',
    [nftContractAddr, tokenId]
  );

  const overrides = {
    gasLimit
  };

  const res = await marketContract.cancelDutchAuctionListing(
    nftContractAddr,
    tokenId,
    overrides
  );
  const transactionHash = res.hash;
  await provider.waitForTransaction(res.hash, 11);

  return { tokenId, transactionHash };
}
export async function getSellerTimestamp(nftContractAddr: any, nftId: any) {
  const marketAddress = getMarketplaceContractAddress(nftContractAddr);
  let marketAbiName = 'Marketplace';
  const bunicornMarketplaceAddress =
    config.projects.bunicornGame.marketplaceAddress;
  if (
    marketAddress.toLowerCase() === bunicornMarketplaceAddress.toLowerCase()
  ) {
    marketAbiName = 'BunicornMarketplace';
  }

  const marketContract = new Contract(
    marketAddress,
    abi[marketAbiName],
    provider
  );
  const [startTime, endTime] = await marketContract.getSellerTimestamp(
    nftContractAddr,
    nftId
  );
  return {
    startTime: new BigNumber(startTime._hex).toNumber(),
    endTime: new BigNumber(endTime._hex).toNumber()
  };
}

export async function getDutchAuctionTimestamp(
  nftContractAddr: any,
  nftId: any
) {
  const abiName = 'BunicornNFTAuctionMarketplace';

  const marketContract = new Contract(
    config.addresses.bunicornNFTAuctionMarketplace,
    abi[abiName],
    provider
  );
  const auction = await marketContract.getDutchAuctionListing(
    nftContractAddr,
    nftId
  );
  return {
    startTime: auction.startingTime.toString(),
    endTime: auction.expirationTime.toString()
  };
}

export async function getTokenBalance(userAddress: any, tokenAddress: any) {
  if (!userAddress || !tokenAddress) return 0;
  const amount = await fetchUserBalance(tokenAddress, userAddress);
  return amount;
}
export async function offer(
  tokenAddress: any,
  id: any,
  currencyAddress: any,
  price: any,
  expirationTime: any,
  isDutchAuctionMarket: any
) {
  const authProvider = await store.getters['auth/authProvider'];
  const marketAddress = isDutchAuctionMarket
    ? config.addresses.bunicornNFTAuctionMarketplace
    : getMarketplaceContractAddress(tokenAddress);

  const currencyContract = new Contract(
    currencyAddress,
    abi['ERC20'],
    authProvider.getSigner()
  );

  const allowance = await currencyContract.allowance(
    store.state.auth.address,
    marketAddress
  );
  if (new BigNumber(price).gt(allowance.toString())) {
    try {
      const res1 = await currencyContract.approve(
        marketAddress,
        MaxUint256.toString()
      );
      await provider.waitForTransaction(res1.hash, Web3.givenProvider ? 1 : 6);
    } catch (_e) {
      const e: any = _e;
      if (e.code && e.code === 4001) {
        throw e;
      }
      const res2 = await currencyContract.approve(marketAddress, price);
      await provider.waitForTransaction(res2.hash, Web3.givenProvider ? 1 : 6);
    }
  }
  const abiContract = isDutchAuctionMarket
    ? abi['BunicornNFTAuctionMarketplace']
    : abi['Marketplace'];
  const offerFunction = isDutchAuctionMarket
    ? 'offerDutchAuction'
    : 'offerListing';

  const nftMarketContract = new Contract(
    marketAddress,
    abiContract,
    authProvider.getSigner()
  );
  const gasLimit = await estimateGas(nftMarketContract, offerFunction, [
    tokenAddress,
    id,
    currencyAddress,
    price,
    expirationTime
  ]);
  const overrides = {
    gasLimit
  };
  const res = await nftMarketContract[offerFunction](
    tokenAddress,
    id,
    currencyAddress,
    price,
    expirationTime,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;
  return { id, price, transactionHash };
}

export async function getDutchAuctionListing(tokenAddress: any, tokenId: any) {
  const address = config.addresses.bunicornNFTAuctionMarketplace;
  const dutchAuctionContract = new Contract(
    address,
    abi['BunicornNFTAuctionMarketplace'],
    provider
  );

  const {
    currency,
    endingPrice,
    expirationTime,
    decliningInterval
  } = await dutchAuctionContract.getDutchAuctionListing(tokenAddress, tokenId);
  return { currency, endingPrice, expirationTime, decliningInterval };
}
export async function getDutchAuctionFinalPrice(
  tokenAddress: any,
  tokenId: any
) {
  const marketAddress = config.addresses.bunicornNFTAuctionMarketplace;
  console.log('getDutchAuctionFinalPrice', tokenAddress, tokenId);

  const dutchAuctionContract = new Contract(
    marketAddress,
    abi['BunicornNFTAuctionMarketplace'],
    provider
  );
  const res = await dutchAuctionContract.getDutchAuctionFinalPrice(
    tokenAddress,
    tokenId
  );
  return res;
}

export async function acceptOfferDutchAuction(
  tokenAddress: any,
  tokenId: any,
  offerer: any,
  offerPrice: any,
  offerCurrency: any
) {
  const provider = await store.getters['auth/authProvider'];
  const marketAddress = config.addresses.bunicornNFTAuctionMarketplace;
  const marketContract = new Contract(
    marketAddress,
    abi['BunicornNFTAuctionMarketplace'],
    provider.getSigner()
  );

  const gasLimit = await estimateGas(
    marketContract,
    'acceptOfferDutchAuction',
    [tokenAddress, tokenId, offerer, offerPrice, offerCurrency]
  );
  const overrides = {
    gasLimit
  };
  const res = await marketContract.acceptOfferDutchAuction(
    tokenAddress,
    tokenId,
    offerer,
    offerPrice,
    offerCurrency,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;
  return { tokenId, transactionHash };
}

export async function acceptOfferListing(
  tokenAddress: any,
  tokenId: any,
  offerer: any,
  offerPrice: any,
  offerCurrency: any
) {
  const provider = await store.getters['auth/authProvider'];
  const marketAddress = getMarketplaceContractAddress(tokenAddress);
  const marketContract = new Contract(
    marketAddress,
    abi['Marketplace'],
    provider.getSigner()
  );
  const gasLimit = await estimateGas(marketContract, 'acceptOfferListing', [
    tokenAddress,
    tokenId,
    offerer,
    offerPrice,
    offerCurrency
  ]);
  const overrides = {
    gasLimit
  };
  const res = await marketContract.acceptOfferListing(
    tokenAddress,
    tokenId,
    offerer,
    offerPrice,
    offerCurrency,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;
  return { tokenId, transactionHash };
}

export async function fetchUsersBalance(
  currencyAddress: any,
  userAddresses: any
) {
  const callGetBalance: any = [];
  userAddresses.forEach((userAddress: any) => {
    callGetBalance.push({
      address: currencyAddress,
      name: 'balanceOf',
      params: [userAddress]
    });
  });
  // @ts-ignore
  const res = await multicall(provider, abi['ERC20'], callGetBalance);
  return res;
}
export async function cancelOfferListing(tokenAddress: any, tokenId: any) {
  const provider = await store.getters['auth/authProvider'];
  const marketAddress = getMarketplaceContractAddress(tokenAddress);
  const marketContract = new Contract(
    marketAddress,
    abi['Marketplace'],
    provider.getSigner()
  );
  const gasLimit = await estimateGas(marketContract, 'cancelOffer', [
    tokenAddress,
    tokenId
  ]);
  const overrides = {
    gasLimit
  };
  const res = await marketContract.cancelOffer(
    tokenAddress,
    tokenId,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;
  return { tokenId, transactionHash };
}
export async function cancelOfferDutchAuction(tokenAddress: any, tokenId: any) {
  const provider = await store.getters['auth/authProvider'];
  const marketAddress = config.addresses.bunicornNFTAuctionMarketplace;
  const marketContract = new Contract(
    marketAddress,
    abi['BunicornNFTAuctionMarketplace'],
    provider.getSigner()
  );
  const gasLimit = await estimateGas(marketContract, 'cancelOffer', [
    tokenAddress,
    tokenId
  ]);
  const overrides = {
    gasLimit
  };
  const res = await marketContract.cancelOffer(
    tokenAddress,
    tokenId,
    overrides
  );
  await provider.waitForTransaction(res.hash, Web3.givenProvider ? 1 : 6);
  const transactionHash = res.hash;
  return { tokenId, transactionHash };
}

export async function getMarketOfferPrice(
  marketAddress: any,
  tokenAddress: any,
  tokenId: any,
  offerer: any
) {
  const marketContract = new Contract(
    marketAddress,
    abi['Marketplace'],
    provider
  );
  const res = await marketContract.getOfferDetail(
    tokenAddress,
    tokenId,
    offerer
  );
  return res;
}

export async function getDutchAuctionOfferPrice(
  marketAddress: any,
  tokenAddress: any,
  tokenId: any,
  offerer: any
) {
  const dutchAuctionContract = new Contract(
    marketAddress,
    abi['BunicornNFTAuctionMarketplace'],
    provider
  );
  const res = await dutchAuctionContract.getOfferDetail(
    tokenAddress,
    tokenId,
    offerer
  );
  return res;
}

export function transformTraitType(traitType) {
  return _.upperFirst(traitType.replace(/([A-Z, 1-9])/g, ' $1').trim());
}
